import React, { useState, useEffect } from 'react'
import { callApi } from '../common/helpers'
import { PaidLeaveContext } from './paidLeaveContext'
import { useAuth } from '../auth/useAuth'
import { range } from '../common/utils/functionalUtility'

// Beware.  This fires before the user has even signed in.  I don't know why.  Yet.
export const PaidLeaveProvider = ({ children }) => {
  const auth = useAuth()
  const accountData = JSON.parse(global.sessionStorage.getItem('accountData'))
  const companyIdFromSession = auth.company ? auth.company._id : null

  const [companyId, setCompanyId] = useState(null)
  const [paidLeaveData, setPaidLeaveData] = useState(null)
  const [selectedProduct, setSelectedProduct] = useState(null)

  const getPaidLeaveData = async () => {
    const JD_PAGE_SIZE = 100
    const generateGetJdOptions = (pageNumber) => ({
      method: 'GET',
      api: 'jurisdiction',
      baseURL: MINWAGE_BASE_PATH,
      params: {
        product: 'paidLeave,paidSickLeave,paidFamilyMedicalLeave',
        collections: 'topics',
        page: pageNumber,
        pageSize: JD_PAGE_SIZE
      }
    })

    const firstResult = await callApi(generateGetJdOptions(1))
    const initialJds = firstResult && firstResult.data
    const totalJds = firstResult && firstResult && firstResult.total

    const pagesToGet = range(Math.floor(totalJds / JD_PAGE_SIZE), 2)
    const apiPromises = pagesToGet.map((pageNumber) => callApi(generateGetJdOptions(pageNumber)))

    const apiResults = await Promise.all(apiPromises)

    return apiResults.reduce((concatenatedJds, apiResult) => concatenatedJds.concat(apiResult.data), initialJds)
  }

  useEffect(() => {
    let subscribed = true
    if (companyId) {
      getPaidLeaveData().then((allPaidLeaveJurisdictions) => {
        if (subscribed) setPaidLeaveData(allPaidLeaveJurisdictions)
      }).catch((error) => {
        console.log(`Error while retrieving paid leave topics ${error}`)
      })
    }
    return () => { subscribed = false }
  }, [companyId])

  useEffect(() => {
    let subscribed = true
    if (String(companyIdFromSession) !== String(companyId) && subscribed) setCompanyId(companyIdFromSession)

    return () => { subscribed = false }
  }, [auth.company, accountData])

  return (
    <PaidLeaveContext.Provider value={{
      paidLeaveData,
      selectedProduct,
      setSelectedProduct
    }}
    >
      {children}
    </PaidLeaveContext.Provider>
  )
}
